import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit, Delete, ArrowDropDown } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import DeleteModal from '../reusable/deleteModal/DeleteModal';
import { useNavigate } from 'react-router-dom';
import PasswordModal from '../reusable/passwordModal/PasswordModal';
import { deleteAdminThunk, setEditAdminData } from '../../redux/admin/adminSlice';
import Operations from '../reusable/Operations';
import { fomateDate } from '../../utils/fomateDate';
import CatPagination from '../reusable/catPagination/CatPagination';

// Styled components using MUI's `styled` API
const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  border: '1px solid #E0E2E7',
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f8f9fa',
  color: '#495057',
  padding: '6px 0px 0px 20px',
  fontFamily: `'Public Sans', sans-serif !important`,

}));

const TableCells = styled(TableCell)(({ theme }) => ({
  paddingLeft: '20px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionIcons = styled(TableCell)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  paddingLeft: '6px',
  borderBottom: '1px solid rgba(224, 224, 224, 1)',
}));

const ProductText = styled(TableCell)(({ theme }) => ({
  color: '#495057',
  fontWeight: 'bold',
  paddingLeft: '6px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const InactiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#ffc9c9',
  color: '#d9534f',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActiveChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#d4edda',
  color: '#28a745',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Reject = styled(Chip)(({ theme }) => ({
  background: 'transparent',
  color: '#E95555',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Approve = styled(Chip)(({ theme }) => ({
  backgroundColor: '#2DA85E',
  color: '#fff',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));



const AllAdminUsersTable = ({ admins, page, setPage, itemsPerPage, start, end, totalItems,handleOpenMenu }) => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPassopen, setIsopen] = useState(false)
  const [selectedId, setSelectedId] = useState(null)


 


  const deletesubCategory = (password) => {
    dispatch(deleteAdminThunk({ id: selectedId, password }))
    setIsModalOpen(false);

  }


  const handleDeleteClick = (id) => {
    setIsModalOpen(true);
    setSelectedId(id)
  };

  const handleEditClick = (admin) => {
    dispatch(setEditAdminData(admin));
    navigate(`/admin/editAdmin/${admin._id}`)
  };

  const handlePassClick =(id)=>{
     setIsopen(true)
     setSelectedId(id)
  }


  return (
    <>

      <TableContainerStyled component={Paper}>
        <Table>
          <TableHead>
            <TableRow>

              <HeaderCell>
                Admin user
                <IconButton onClick={(e) => handleOpenMenu('name')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell sx={{ paddingLeft: '10px' }}>
                Phone number
              </HeaderCell>

              <HeaderCell sx={{ paddingLeft: '10px' }}>
                Email
              </HeaderCell>

              <HeaderCell>
                Status
                <IconButton onClick={(e) => handleOpenMenu('status')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Register date
                <IconButton onClick={(e) => handleOpenMenu('createdAt')}>
                  <ArrowDropDown />
                </IconButton>
              </HeaderCell>

              <HeaderCell>
                Action
              </HeaderCell>
            </TableRow>

          </TableHead>

          <TableBody >
            {admins.map((row) => (
              <TableRow key={row._id}>


                <TableCells sx={{
                  width: '20%',

                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div>
                      {
                        row?.thumbnail?.photo ? <img src={row?.thumbnail?.photo} style={{ width: 44, height: 44, borderRadius: 2 }} /> : <img src="/assets/profile.png" />
                      }
                    </div>
                    <div>
                      <strong style={{ color: '#1D1F2C' }}>{row.name}</strong>
                    </div>
                  </div>
                </TableCells>



                <ProductText sx={{ width: '12%', color: "#667085", }}>
                  {row?.phone}
                </ProductText>

                <ProductText sx={{ width: '12%', color: "#667085", }}>
                  {row?.email}
                </ProductText>

                <TableCells sx={{ width: '11%' }}>
                  {row?.status === "ACTIVE" ? (
                    <ActiveChip label="Active" size="small" />
                  ) : (
                    <InactiveChip label="Inactive" size="small" />
                  )}
                </TableCells>



                <TableCells sx={{ width: '14%', fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                  {fomateDate(row.createdAt)}
                </TableCells>

                <Operations sx={{ width: '11%', }}
                  TableCells={TableCells}
                  viewClick={() => navigate(`/admin/viewAdmin/${row?._id}`)}
                  editClick={() => handleEditClick(row)}
                  deleteClick={() => handleDeleteClick(row?._id)}
                  passwordClick={() => handlePassClick(row?._id)}
                  showpass={'show'}
                />

                <DeleteModal
                  isOpen={isModalOpen}
                  heading={'Admin'}
                  onClose={() => setIsModalOpen(false)}
                  onDelete={deletesubCategory}
                />
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div>
          <CatPagination
            start={start}
            end={end}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            setPage={setPage}
            page={page}
          />

          <PasswordModal
            isOpen={isPassopen}
            onClose={() => setIsopen(false)}
            selectedId={selectedId}

          />
        </div>
      </TableContainerStyled>

    </>
  );
};

export default AllAdminUsersTable;
